import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS].GET_INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS]: {
		url: '/company/:companyId/incidents/my_works/to_administrate_incidents/',
	},
	
}